// ZUSATZ-2 (Meldung 72bfc760, 22.10.2026): auf Marvins Bildschirmfoto stand bei
// BEIDEN Dachflaechen «Ziegeldach Tonziegel» — gespeichert war Ziegel + Trapez.
// Die App zeigte richtig; das Bild log. modern-screenshot klont die Seite und
// setzt bei einem Auswahlfeld nur das Attribut `value`, das ein <select> nicht
// kennt — der Klon zeigt darum immer die erste Option.
//
// Abhilfe: fuer die Dauer der Aufnahme traegt die gewaehlte Option das Attribut
// `selected` (das klont mit), danach wird genau das zurueckgenommen, was hier
// gesetzt wurde. Die Auswahl selbst bleibt unberuehrt.

export async function mitAuswahlImBild<T>(wurzel: ParentNode, aufnahme: () => Promise<T>): Promise<T> {
  const gesetzt: HTMLOptionElement[] = [];
  for (const select of Array.from(wurzel.querySelectorAll("select"))) {
    const option = select.selectedIndex >= 0 ? select.options[select.selectedIndex] : undefined;
    if (option && !option.hasAttribute("selected")) {
      option.setAttribute("selected", "");
      gesetzt.push(option);
    }
  }
  try {
    return await aufnahme();
  } finally {
    for (const option of gesetzt) option.removeAttribute("selected");
  }
}
